var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BareLayout',{staticClass:"text-white integrations"},[_c('section-hero',{attrs:{"section-hero":_vm.sectionHero}}),_vm._v(" "),(_vm.sectionContent)?_c('section-content',{attrs:{"section-content":_vm.sectionContent}}):_vm._e(),_vm._v(" "),(_vm.showPhotoGallery)?_c('section-gallery',{attrs:{"section-gallery":_vm.sectionGallery}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }